// MyTimesService.js - Service für MyTimes-spezifische API-Aufrufe
import API_ENDPOINTS from '../config/apiEndpoints';

class MyTimesService {
  /**
   * Holt Zeiteinträge (Version 2) für einen bestimmten Mitarbeiter und Monat
   * @param {string} token - Access Token
   * @param {string} employeeId - Mitarbeiter-ID
   * @param {string} month - Monat im Format YYYY-MM (optional bei year)
   * @param {number} year - Jahr (optional, wenn nicht month verwendet)
   * @returns {Promise<Object>} API Response mit Zeiteinträgen
   */
  static async getTimesVersion2(token, employeeId, month = null, year = null) {
    console.log('MyTimesService.getTimesVersion2 called with:', { 
      token: token ? 'Present' : 'Missing', 
      employeeId, 
      month,
      year
    });
    console.log('URL:', API_ENDPOINTS.GET_TIMES_V2);
    
    const requestBody = {
      token,
      employeeId
    };
    
    if (month) {
      requestBody.month = month;
    }
    
    if (year) {
      requestBody.year = year;
    }
    
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Request-Headers': '*',
      },
      body: JSON.stringify(requestBody),
      redirect: 'follow'
    };

    try {
      const response = await fetch(API_ENDPOINTS.GET_TIMES_V2, requestOptions);
      
      console.log('getTimesVersion2 response status:', response.status);
      console.log('getTimesVersion2 response ok:', response.ok);
      
      const result = await response.json();
      console.log('getTimesVersion2 result:', result);
      console.log('getTimesVersion2 result type:', typeof result);
      console.log('getTimesVersion2 result length:', Array.isArray(result) ? result.length : 'Not an array');
      
      return result;
    } catch (error) {
      console.error('Error in MyTimesService.getTimesVersion2:', error);
      throw error;
    }
  }

  /**
   * Holt den Jahresplan für einen Mitarbeiter
   * @param {string} token - Access Token
   * @returns {Promise<Object>} API Response mit Jahresplan
   */
  static async getAnnualPlan(token) {
    console.log('MyTimesService.getAnnualPlan called with token:', token ? 'Present' : 'Missing');
    console.log('URL:', API_ENDPOINTS.GET_ANNUAL_PLAN);
    
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Request-Headers': '*',
      },
      body: JSON.stringify({ token }),
      redirect: 'follow',
    };

    try {
      const response = await fetch(API_ENDPOINTS.GET_ANNUAL_PLAN, requestOptions);
      
      console.log('getAnnualPlan response status:', response.status);
      console.log('getAnnualPlan response ok:', response.ok);
      
      const result = await response.json();
      console.log('getAnnualPlan result:', result);
      
      return result;
    } catch (error) {
      console.error('Error in MyTimesService.getAnnualPlan:', error);
      throw error;
    }
  }

  /**
   * Holt den Urlaubsplan für einen Mitarbeiter
   * @param {string} token - Access Token
   * @returns {Promise<Object>} API Response mit Urlaubsplan
   */
  static async getHolidayPlan(token) {
    console.log('MyTimesService.getHolidayPlan called with token:', token ? 'Present' : 'Missing');
    console.log('URL:', API_ENDPOINTS.GET_HOLIDAY_PLAN);
    
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Request-Headers': '*',
      },
      body: JSON.stringify({ token }),
      redirect: 'follow',
    };

    try {
      const response = await fetch(API_ENDPOINTS.GET_HOLIDAY_PLAN, requestOptions);
      
      console.log('getHolidayPlan response status:', response.status);
      console.log('getHolidayPlan response ok:', response.ok);
      
      const result = await response.json();
      console.log('getHolidayPlan result:', result);
      
      return result;
    } catch (error) {
      console.error('Error in MyTimesService.getHolidayPlan:', error);
      throw error;
    }
  }

  /**
   * Erstellt eine Änderungsanfrage für einen Zeiteintrag
   * @param {Object} changeRequestData - Daten für die Änderungsanfrage
   * @returns {Promise<Object>} API Response
   */
  static async addChangeRequest(changeRequestData) {
    console.log('MyTimesService.addChangeRequest called with data:', changeRequestData);
    console.log('URL:', API_ENDPOINTS.ADD_CHANGE_REQUEST);
    
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Request-Headers': '*',
      },
      body: JSON.stringify(changeRequestData),
      redirect: 'follow'
    };

    try {
      const response = await fetch(API_ENDPOINTS.ADD_CHANGE_REQUEST, requestOptions);
      
      console.log('addChangeRequest response status:', response.status);
      console.log('addChangeRequest response ok:', response.ok);
      
      const result = await response.json();
      console.log('addChangeRequest result:', result);
      
      return result;
    } catch (error) {
      console.error('Error in MyTimesService.addChangeRequest:', error);
      throw error;
    }
  }
}

export default MyTimesService;
